/* ============
 * Array Mixin
 * ============
 */
import { getFormattedDate, addDays, defaultDateFormat, defaultTimeFormat, getDaysFromNow, getDateFromNow } from '@/utils/date';

export default {
  /**
   * The methods that the mixin used for array functions.
   */
  methods: {
    /**
     * Method used to format date
     */
    getFormattedDate,
    addDays,
    defaultDateFormat,
    defaultTimeFormat,
    getDaysFromNow,
    getDateFromNow
  }
};
